import { Component, effect, input, model, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatOption } from '@angular/material/autocomplete';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { FilterItemWithLabel } from '@vectronic/util';
import { FilterHeaderComponent } from '../filter-header/filter-header.component';

@Component({
  selector: 'vectronic-selection-filter-with-header',
  templateUrl: './selection-filter-with-header.component.html',
  styleUrls: ['./selection-filter-with-header.component.scss'],
  imports: [FilterHeaderComponent, MatFormField, MatLabel, MatOption, MatSelect, FormsModule],
})
export class SelectionFilterWithHeaderComponent<T> {
  title = input.required<string>();
  availableFilterItems = input.required<FilterItemWithLabel<T>[]>();
  selectedItem = model<T>(undefined);
  hideLabel = input(false);

  @ViewChild(MatSelect) private matSelect: MatSelect;
  isFilterHidden = model(true);

  // noinspection JSUnusedGlobalSymbols
  setFilterActiveWhenSelectedItemIsValid = effect(() => {
    if (this.selectedItem() != undefined) {
      this.isFilterHidden.set(false);
    }
  });

  // noinspection JSUnusedGlobalSymbols
  focusFilterInputOnShow = effect(() => {
    if (!this.isFilterHidden() && this.selectedItem() == null) {
      setTimeout(() => this.matSelect?.open());
    }
  });

  toggleFilter() {
    if (!this.isFilterHidden()) {
      this.selectedItem.set(undefined);
    }
    this.isFilterHidden.update((old) => !old);
  }
}
